import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const DISCOVER_FEATURE_FLAG = 'discover-page';

export const discoverPlugin = createPlugin({
  id: 'discover',
  routes: {
    root: rootRouteRef,
  },
  featureFlags: [
    {
      name: DISCOVER_FEATURE_FLAG,
      description: 'Show the Discover page and its sidebar entry.',
    },
  ],
});

export const DiscoverPage = discoverPlugin.provide(
  createRoutableExtension({
    name: 'DiscoverPage',
    component: () =>
      import('./components/DiscoverPage').then(m => m.DiscoverPage),
    mountPoint: rootRouteRef,
  }),
);
